import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
    position: "relative",
  },
  header: {
    padding: theme.spacing(3, 3, 0, 3),
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  content: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(10),
  },
  section: {
    padding: theme.spacing(2, 0),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  sectionDivider: {
    marginBottom: theme.spacing(2),
  },
  bottomButtons: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    zIndex: theme.zIndex.drawer + 1,
  },
  buttonWrapper: {
    padding: theme.spacing(0, 3),
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
  },
  saveButton: {
    minWidth: 100,
  },
  closeButton: {
    minWidth: 100,
  },
  facilityParentSpacing: {
    marginLeft: 10,
    marginTop: 20,
  },
  facilityParentIconSpacing: {
    marginRight: 10,
  },
  facilityGroupSpacing: {
    paddingLeft: "40px !important",
    margin: "5px 0 10px 0",
  },
  facilityGroupIconContainer: {
    display: "inline-block",
    minWidth: "30px",
  },
  facilityGroupLabel: {
    display: "inline-block",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  standAloneFacility: {
    paddingLeft: `40px !important`,
    "& .MuiListItemIcon-root": {
      minWidth: "30px",
    },
  },
  nestedFacility: {
    paddingLeft: `80px !important`,
    "& .MuiListItemIcon-root": {
      minWidth: "30px",
    },
  },
  singleFacilityText: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    fontWeight: 500,
    cursor: "help",
  },
  themeToggleContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  transparentSubheader: {
    backgroundColor: "transparent",
    padding: 0,
  },
  transparentSubheaderGroup: {
    backgroundColor: "transparent",
  },
  facilityNameSpacing: {
    marginLeft: "10px",
  },
  dropdownPaper: {
    maxHeight: 400,
    width: 350,
  },
  nonStickySubheader: {
    position: "static !important",
    top: "auto !important",
  },
}));
